import { LabelLarge } from "../../../../global/ui/typography";
import { useListingReviewCardContext } from "./ListingReviewCardProvider";

export const ListingReviewCardUsername = () => {
  const { state } = useListingReviewCardContext();

  return <LabelLarge>{state.review.user.name}</LabelLarge>;
};
